import Component from 'vue-class-component';

import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import BaseComponent from '@/components/base/BaseComponent';
import { Action, Getter } from 'vuex-class';
import { GET_ORG_NEWS, ORG_NEWS } from '@/types/lobby.types';

@Component({})
export default class MessagesComponent extends BaseComponent {

  @Action(GET_ORG_NEWS, StoreNamespace.LOBBY) public getOrgNews;

  @Getter(ORG_NEWS, StoreNamespace.LOBBY) public messages: any;

  public mounted() {
    this.getOrgNews();
  }

}

